<template>
  <z-form tag="form" class="z-card">
    <h4>{{ $t('pbx.phone-list.form.title.edit.added_phones') }}</h4>
    <div class="z-card__body">
      <div class="row">
        <div class="col-10 offset-2">
          <numbers-list @on-remove="removePhone" />
        </div>
      </div>
    </div>
  </z-form>
</template>

<script>
  import { mapActions } from 'vuex';
  import NumbersList from './list';

  export default {
    components: {
      NumbersList
    },
    methods: {
      ...mapActions('pbx/phone-lists/form/table', ['removePhone'])
    }
  };
</script>
